(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbx-pricing"] && !Shopify.designMode) return;
  try {
    
  const openPricingComparison = (hash) => {
    if (!hash.startsWith('#Compare-')) return;
    const comparison = document.getElementById(hash.slice(1));
    if (comparison?.matches('.sbp details.sbp__comparison')) comparison.open = true;
  };
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[data-sbp-compare]');
    if (link) openPricingComparison(link.getAttribute('href') || '');
  });
  window.addEventListener('hashchange', () => openPricingComparison(window.location.hash));
  openPricingComparison(window.location.hash);

  } catch(e) { console.error(e); }
})();
})();
